import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const ExpertsIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/experts'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_experts_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_experts_list',
          component: ExpertsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
